export default __webpack_public_path__ + "static/media/time-entries-tab.0dfaf622.png";